module.exports = __webpack_public_path__ + "static/media/youtube.8657cf42.svg";